module.exports = __webpack_public_path__ + "static/media/EGOM2_EDITSINGLE2.fd2f726b.mp4";